import { composeIO } from 'react-compose-io'
import { headerTabelaResultadosOPSIO } from './HeaderTabelaResultadosOPS.IO'
import { HeaderTabelaResultadosOPSView } from './HeaderTabelaResultadosOPS.View'

export const HeaderTabelaResultadosOPS = composeIO(HeaderTabelaResultadosOPSView, headerTabelaResultadosOPSIO)
